import { Types } from "@grandvisionhq/graphql";
const mapPaymentDataToCustomerDetails = (paymentData, locale, country) => {
  const paymentDataResponse = paymentData?.response;
  const address = paymentDataResponse?.shippingAddress;
  const paymentCustomerDetails = paymentDataResponse?.customerDetails;
  if (!address) {
    throw new Error("Missing shipping address in payment data");
  }
  if (!paymentCustomerDetails) {
    throw new Error("Missing customer details in payment data");
  }
  const firstName = paymentCustomerDetails.firstName;
  const lastName = paymentCustomerDetails.lastName;
  if (!firstName || !lastName || !address.city) {
    throw new Error("Missing required fields for customer details input");
  }
  const shippingAddress = {
    streetName: address.addressLine1 || "",
    additionalStreetInfo: address.addressLine2,
    countryCode: country,
    city: address.city,
    firstName,
    lastName,
    postalCode: address.postalCode,
    streetNumber: null,
    externalId: null,
    region: null,
    salutation: null,
    title: null,
    middleName: null,
    pOBox: null,
    company: null,
    apartment: null,
    building: null,
    department: null,
    key: null
  };
  const customerDetails = {
    email: paymentCustomerDetails.email,
    phone: paymentCustomerDetails.phone,
    customerType: Types.CheckoutCustomerType.B2C,
    dateOfBirth: null,
    IBAN: null
  };
  const invoiceDetails = {
    certifiedEmail: null,
    certifiedRecipientCode: null,
    customerCode: null,
    insuranceNumber: null,
    insuranceProvider: null,
    vatId: null
  };
  return {
    locale,
    shippingAddress,
    billingAddress: shippingAddress,
    customerDetails,
    invoiceDetails,
    marketingEmailsOptIn: false
  };
};
export {
  mapPaymentDataToCustomerDetails
};
//# sourceMappingURL=map-payment-data-to-customer-details.js.map
